module.exports = __webpack_public_path__ + "static/media/03.adobe-indesign.3aebccc2.svg";